import { Button as DevButton } from 'devextreme-react/button';
import DataGrid, {
    Column, FilterPanel, FilterRow,
    HeaderFilter, Selection, Sorting
} from 'devextreme-react/data-grid';
import React, { useEffect, useState } from "react";
import { hachToanCongNoApi } from "../../../api/hachToanCongNopApi";
import { thuPhiApi } from "../../../api/thuPhiApi";
import { showNotify } from "../../../helpers/toast";
import { IBaseResponeModel } from '../../../models/response/base-response';
import { sf_hachtoan_congno_viewmodel } from "../../../models/response/hach-toan-cong-no/sf_hachtoan_congno";
import { sf_mucphaithu } from "../../../models/response/thu-phi/sf_mucphaithu";
import { Button } from "../../buttons";
import { DefaultPopup } from "../../modal";
import { mucPhaiThuChiTietApi } from '../../../api/mucPhaiThuChiTietApi';
export type HoanPhiQuyetToanBtnProps = {
    disabled: boolean,
    sf_mucphaithu: sf_mucphaithu,
    onChanged: () => void
}
const HoanPhiQuyetToanBtn = (props: HoanPhiQuyetToanBtnProps) => {
    const [isShowModal, setIsShowModal] = useState<boolean>(false);
    const [hachToanCongNoPendings, setHachToanCongNoPendings] = useState<sf_hachtoan_congno_viewmodel[]>([]);
    const [hachToanCongNoUsedIds, setHachToanCongNoUsedIds] = useState<number[]>([]);

    useEffect(() => {
        if (!props.disabled && props.sf_mucphaithu) {
            handleReloadHoanPhiPending();
        }
    }, [hachToanCongNoUsedIds])

    useEffect(() => {
        if (!props.disabled && props.sf_mucphaithu) {
            handleReloadQuyetToanDaNop();
            // handleReloadHoanPhiPending();
        }
    }, [props.sf_mucphaithu, props.disabled])
    const handleReloadHoanPhiPending = async () => {
        const res = await hachToanCongNoApi.select_by_hocsinh({
            nam_hoc: props.sf_mucphaithu.nam_hoc,
            ts_hocsinh_id: props.sf_mucphaithu.ts_hocsinh_id,
            is_added_tbtp: false
        });
        if (res.is_success) {
            const data = res.data.filter((x: sf_hachtoan_congno_viewmodel) => !x.is_da_thanh_toan && !hachToanCongNoUsedIds.includes(x.id))
            setHachToanCongNoPendings(data)
        }
    }
    const handleReloadQuyetToanDaNop = async () => {
        const res = await mucPhaiThuChiTietApi.select_quuyetoan_dasudung_by_hocsinh({
            nam_hoc: props.sf_mucphaithu.nam_hoc,
            ts_hocsinh_id: props.sf_mucphaithu.ts_hocsinh_id
        });
        if (res.is_success) {
            const data = res.data.map((x: any) => x.sf_hachtoan_congno_id);
            setHachToanCongNoUsedIds(data)
        }
    }
    return (
        <>
            <DevButton
                text={"Thêm khoản quyết toán" + (hachToanCongNoPendings.length > 0 ? ` (${hachToanCongNoPendings.length})` : '')}
                type="default"
                stylingMode="text"
                icon="plus"
                className="p-btn-devextreme"
                disabled={props.disabled || hachToanCongNoPendings.length == 0}
                onClick={() => {
                    setIsShowModal(true);
                }}
            />
            {isShowModal && <ThuPhiAddHoanPhiModal
                onClose={() => { setIsShowModal(false) }}
                hachToanCongNoPendings={hachToanCongNoPendings}
                sf_mucphaithu={props.sf_mucphaithu}
                onChanged={() => {
                    setIsShowModal(false);
                    props.onChanged();
                }}
            />}
        </>
    )
}
type ThuPhiAddHoanPhiModalProps = {
    sf_mucphaithu: sf_mucphaithu,
    hachToanCongNoPendings: sf_hachtoan_congno_viewmodel[],
    onClose: () => void,
    onChanged: () => void
}

const ThuPhiAddHoanPhiModal = (props: ThuPhiAddHoanPhiModalProps) => {
    const [selectedIds, setSelectedIds] = useState<number[]>([])
    const [isSaving, setIsSaving] = useState<boolean>(false)


    const onSelectionChanged = ({ selectedRowKeys, selectedRowsData }: any) => {
        setSelectedIds(selectedRowKeys);
    }


    const handleSubmit = async () => {
        // console.log("handleSubmit", data)
        setIsSaving(true)
        const hachToanCongNos = props.hachToanCongNoPendings.filter(x => selectedIds.includes(x.id));
        const res: IBaseResponeModel = await thuPhiApi.insert_from_khoannop({
            nam_hoc: props.sf_mucphaithu.nam_hoc,
            sf_mucphaithu_id: props.sf_mucphaithu.id,
            is_tinh_mien_giam: false,
            sf_mucthuphis: hachToanCongNos.map((hachToanCongNo: sf_hachtoan_congno_viewmodel) => {
                return {
                    id: 0,
                    sf_mucthuphi_id: 0,
                    so_tien_phai_nop: hachToanCongNo.is_hoan_tra ? -(1 * hachToanCongNo.tong_tien) : hachToanCongNo.tong_tien,
                    ghi_chu: "",
                    sf_hachtoan_congno_id: hachToanCongNo.id
                }

            }),
            ts_hocsinh_id: props.sf_mucphaithu.ts_hocsinh_id
        })
        setIsSaving(false)
        if (res.is_success) {
            showNotify({ message: "Đã thêm thành công", type: "success" })
            props.onChanged();
            props.onClose();
        } else {
            showNotify({ message: res.message || "Có lỗi xảy ra", type: "error" });
            props.onChanged();
        }
    }
    return (
        <div>
            <DefaultPopup title="Hoàn phí/ Quyết toán" maxWidth={600}>
                <div className="pop-up-form">
                    <DataGrid
                        keyExpr={"id"}
                        dataSource={props.hachToanCongNoPendings}
                        columnHidingEnabled={false}
                        columnAutoWidth={true}
                        showBorders={true}
                        showColumnLines={false}
                        showRowLines={false}
                        rowAlternationEnabled={true}
                        allowColumnResizing={true}
                        columnResizingMode={"nextColumn"}
                        hoverStateEnabled={true}
                        focusedRowEnabled={false}
                        height={window.innerHeight - 350}
                        noDataText="Không có dữ liệu"
                        selectedRowKeys={selectedIds}
                        onSelectionChanged={onSelectionChanged}
                        paging={{ enabled: false }}
                        wordWrapEnabled={true}
                        loadPanel={{ enabled: false }}
                    >
                        <Sorting mode="multiple" />
                        <Selection mode="multiple" allowSelectAll={false} showCheckBoxesMode="always"></Selection>
                        <FilterRow visible={true} />
                        <FilterPanel visible={false} />
                        <HeaderFilter visible={true} />
                        <Column dataField="noi_dung" caption="Nội dung"></Column>
                        <Column dataField="tong_tien" caption="Tổng tiền" minWidth={250} format={"#,000"}></Column>
                    </DataGrid>
                </div>
                <div className="pop-up-actions">
                    <Button text="Đóng" onClick={() => { props.onClose() }} />{' '}
                    <Button text="Áp dụng" type="normal" onClick={handleSubmit} isLoading={isSaving} />
                </div>
            </DefaultPopup>
        </div>
    );
}
export default HoanPhiQuyetToanBtn
